<div class="billing">
  <div class="row mb-4">
    <div class="col-lg-8 col-md-8 col-sm-8">
      <!-- <div class="bill-pay">
        {{ "orderCheckOut.paymentTerm" | cxTranslate }}
        <div class="">
          <strong>
            {{
              fetchedCartReviewOrder?.notificationDetails?.paymentTerms
            }}</strong
          >
        </div>
      </div> -->
      <div class="vs-text-field">
        <label class="bill-pay"
          ><span class="star"></span
          >{{ "orderCheckOut.purchaseOrderNo" | cxTranslate }}</label
        >
        <strong>{{ fetchedCartReviewOrder?.purchaseOrderNumber }}</strong>
      </div>
      <div class="mt-3">
        <div class="upload mt-3 mb-3">
          {{ "orderCheckOut.uploadPurchaseOrder" | cxTranslate }}
        </div>
        <div id="fileInfo" class="fileInfo-section"></div>

        <!--  START    -->
        <div
          id="fileInfo"
          class="fileInfo-section"
          *ngFor="let file of fetchedCartReviewOrder?.poAttachments"
        >
          <i class="material-icons material-icons-custom">receipt</i>
          <span id="para11">{{ file.realFileName }}</span>
          <span id="para22"
            ><strong>{{ getFileSize(file.attachmentSizes) }} </strong></span
          >
        </div>
        <!--   end     -->
      </div>
    </div>

    <div class="col-lg-4 col-sm-4 col-md-4 pl82">
      <div class="row cart-cost">
        <div class="col-lg-6 col-sm-6 col-md-6 right-content padding_0">
          <div class="sub-title">
            {{ "orderCheckOut.subTotal" | cxTranslate }}
          </div>
          <div class="sub-title">
            {{ "orderCheckOut.couponDiscount" | cxTranslate }}
          </div>
          <div class="sub-title">
            {{ "orderCheckOut.surcharge" | cxTranslate }}
            <i class="material-icons custom-info-icon">info</i>
          </div>
          <div class="sub-title" *ngIf="hideTrasnportion">
            {{ "orderCheckOut.transportation" | cxTranslate }}
          </div>
          <div class="cart-total">
            {{ "orderCheckOut.cartTotal" | cxTranslate }} ({{
              fetchedCartReviewOrder?.totalItems
            }}
            items):
          </div>
        </div>
        <div class="col-lg-6 col-sm-6 col-md-6 right-content padding_0">
          <div class="cost">
            {{ fetchedCartReviewOrder?.vsSubTotal?.currencyIso }}
            {{ fetchedCartReviewOrder?.vsSubTotal?.formattedValue }}
          </div>
          <div class="cost">
            {{ fetchedCartReviewOrder?.orderDiscounts?.currencyIso }}
            {{ getCouponDiscout() }}
          </div>
          <div class="cost">
            {{ fetchedCartReviewOrder?.surCharge?.currencyIso }}
            {{ fetchedCartReviewOrder?.surCharge?.formattedValue }}
          </div>
          <div class="cost height20" *ngIf="hideTrasnportion">
            {{ fetchedCartReviewOrder?.transportationCost?.currencyIso }}
            {{ fetchedCartReviewOrder?.transportationCost?.formattedValue }}
          </div>
          <div class="cart-total">
            {{ fetchedCartReviewOrder?.totalPrice?.currencyIso }}
            {{ fetchedCartReviewOrder?.totalPrice?.formattedValue }}
          </div>
        </div>

        <button [disabled]="orderStatus"
          (click)="openOrderReviewModal()"
          class="vs-primary-btn sample-btn proceedBtn"
        >
          <span>{{ "orderCheckOut.submitOrderBtn" | cxTranslate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
